import { useOutletContext } from "react-router";
import type { ModuleSlug } from "@a2/core";
import { authedFetch } from "./api-client";
import type { SessionUser } from "./session-loader";

export function useDefaultModule(): ModuleSlug | null {
  const session = useOutletContext<SessionUser>();
  return session.defaultModule;
}

export async function setDefaultModule(slug: ModuleSlug): Promise<void> {
  const res = await authedFetch("/user/preferences", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ defaultModule: slug }),
  });
  if (!res.ok) {
    throw new Error(`Failed to set defaultModule: HTTP ${res.status}`);
  }
}
